import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Headers, Http, RequestOptions, Response } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { ParentService } from '../A2-utils/ParentClass/ParentService';
import { constant } from '../../app.constants';

@Injectable()
export class TModulesService extends ParentService {

  constructor(private _http: Http, private route: Router) {
    super();
    // this.verifyToken(this._http, route);
  }

  /**
   * @name getModules
   * @description
   */
  getModules() {
    return this._http
      .get(constant.URL_MODULE, this.getHeader())
      .map(res => res.json());
  }

  /**
   * @name getModuleById
   * @description
   * @param {number} id
   */
  getModuleById(id: number) {
    return this._http
      .get(constant.URL_MODULE + '/' + id, this.getHeader())
      .map(res => res.json());
  }

  /**
   * @name getActionsByModule
   * @description
   * @param {any} data
   */
  getActionsByModule(data: any) {
    return this._http
      .get(constant.URL_MODULEACTIONBYMOD + data, this.getHeader())
      .map(res => res.json(), (error: Response) => error.json());
  }

  /**
   * @name postData
   * @description
   * @param {any} data
   */
  postData(data: any) {
    const bodyString = JSON.stringify(data);
    return this._http.post(constant.URL_MODULE, bodyString, this.headerPost())
      .map((res: Response) => res.json())
      .catch((error: any) => Observable.throw(error.json() || 'Server error'));
  }

  /**
   * @name putData
   * @description
   * @param {any} data
   */
  putData(data: any) {
    const bodyString = JSON.stringify(data);
    return this._http
    .put(constant.URL_MODULE, bodyString, this.headerPost())
      .map((res: Response) => res.json())
      .catch((error: any) => Observable.throw(error.json() || 'Server error'));
  }

  /**
   * @name deleteData
   * @description
   * @param {any} data
   */
  deleteData(data: any) {
    return this._http
      .delete(`${constant.URL_MODULE}/${data}`, this.headerPost())
      .map((res: Response) => res.json())
      .catch((error: any) => Observable.throw(error.json() || 'Server error'));
  }

  /**
   * @name postModuleAction
   * @description
   * @param {any} data
   */
  postModuleAction(data: any) {
    const bodyString = JSON.stringify(data);

    return this._http.post(constant.URL_MODULE_ACTION, bodyString, this.headerPost())
      .map((res: Response) => res.json())
      .catch((error: any) => Observable.throw(error.json() || 'Server error'));
  }

  /**
   * @name deleteModuleAction
   * @description
   * @param data
   */
  deleteModuleAction(data: any) {
    return this._http
      .delete(`${constant.URL_MODULEACTION}/${data}`, this.headerPost())
      .map((res: Response) => res.json())
      .catch((error: any) => Observable.throw(error.json() || 'Server error'));
  }

  /**
   * @name getRoleActionByModule
   * @description
   * @param id
   */
  getRoleActionByModule(id) {
    return this._http.get(constant.URL_GETMODULEACTION + '/' + id, this.getHeader()).map(res => res.json());
  }

  /**
   * @name postSaveLayout
   * @param data
   */
  postSaveLayout(data) {
    const bodyString = JSON.stringify(data);
    return this._http.post(constant.URL_SAVE_LAYOUT, bodyString, this.headerPost())
      .map((res: Response) => res.json())
      .catch((error: any) => Observable.throw(error.json()));
  }

}



// WEBPACK FOOTER //
// ./src/app/pages/t-modules/t-modules.service.ts